import React from 'react';
import QueryBuilder from '@material-ui/icons/QueryBuilder';
import PlaceIcon from '@material-ui/icons/Place';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import StoreMallDirectory from '@material-ui/icons/StoreMallDirectory';
import CartIcon from '@material-ui/icons/ShoppingCart';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import PropTypes from 'prop-types';
import { fulfillmentOptions } from 'cart/constants/fulfillmentOptions';

const NAV_FULFILLMENT_ICONS = {
  [fulfillmentOptions.PICKUP]: <StoreMallDirectory />,
  [fulfillmentOptions.DELIVERY]: <DirectionsCar />,
  time: <QueryBuilder />,
  address: <PlaceIcon />,
  cart: <CartIcon />,
  [fulfillmentOptions.DINE_IN]: <RestaurantMenuIcon />
};

const NavFulfillmentIcon = ({ icon }) => {
  return NAV_FULFILLMENT_ICONS[icon];
};

const navFulfillmentIconKeys = Object.keys(NAV_FULFILLMENT_ICONS);

NavFulfillmentIcon.propTypes = {
  icon: PropTypes.oneOf(navFulfillmentIconKeys)
};

export default NavFulfillmentIcon;
